<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-14 13:44:35
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-16 11:25:46
 * @Description: 按钮组件
 * @FilePath: /hsylc2021/src/components/form/Button/index.vue
-->
<template>
  <button v-loading="loading" class="component-button w-bold" :class="computedClass" @click="handleClickButton" :style="{ ...customStyle }">
    <slot></slot>
  </button>
</template>
<script>
/**
 * 按钮组件
 * @module Button
 */
export default {
  name: 'Button',
  /**
   * @prop {String} size 按钮大小 normal:height-48 / small: height-36  默认normal
   * @prop {String} skin 按钮皮肤 red/black/grey  默认red
   * @prop {Boolean} disabled 是否禁用 true/false  默认false
   * @prop {String} className 组件class name
   * @prop {Object} customStyle 自定义样式
   */
  props: {
    size: {
      type: String,
      default: 'normal'
    },
    skin: {
      type: String,
      default: 'red'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: 'c-btn'
    },
    id: {
      defalut: ''
    },
    color: {
      type: String,
      default: 'default'
    },
    customStyle: {
      type: Object,
      default: function() {
        return {};
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  /**
   * @prop {Object} computedClass 组件class计算属性
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[`size-${this.size}`] = true;
      ret[`skin-${this.skin}`] = true;
      ret[this.className] = true;
      ret['disabled'] = this.disabled;
      ret[`text-${this.color}`] = true;
      return ret;
    }
  },
  methods: {
    /**
     * @event click 点击事件
     * @param {Object} event 事件对象
     */
    click: function(event) {
      this.$emit('click', { event: event }, this.id);
    },
    /**
     * @description 点击按钮事件
     * @function handleClickButton
     * @param {Object} e 事件对象
     */
    handleClickButton: function(e) {
      if (this.loading) return;
      if (!this.disabled) {
        this.click(e);
      }
    }
  }
};
</script>
<style lang="less" src="./index.less" scoped></style>
